import { __spreadArray } from './__helpers/tslib/tslib.es6.js';
import events from '@mongez/events';

var BASE_EVENT_KEY = "endpoint.";
var event = function (eventName) { return BASE_EVENT_KEY + eventName; };
var endpointEvents = {
    beforeSending: function (callback) {
        return events.subscribe(event("sending"), callback);
    },
    onResponse: function (callback) {
        return events.subscribe(event("send"), callback);
    },
    onSuccess: function (callback) {
        return events.subscribe(event("success"), callback);
    },
    onError: function (callback) {
        return events.subscribe(event("error"), callback);
    },
    trigger: function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        events.trigger.apply(events, __spreadArray([event(eventName)], args, false));
    },
};

export { endpointEvents as default };
